// Edit project page by ankita 25/1/2024

import React from "react";
import Sidebar from "../Components/Sidebar";
import maftlal from "../assests/images/mafatlal 1.png";


export default function EditProjectManager() {
  return (
    <Sidebar>
      <>
      <div className="bg-grey-300 p-3 lg:p-3 xl:p-3 2xl:p-6">
          <div className="bg-white h-[76vh]">
            <div className="flex items-center bg-white px-4 py-3 lg:py-2 xl:py-3 2xl:py-3">
              {/* for project manager */}
             <div className="flex-1">
                <div className="flex justify-between lg:w-full px-10 lg:px-1  ">
                  <div className="flex ">
                    <div
                      className=" flex justify-center items-center border rounded-md border-white cursor-pointer">
                      <div className='text-4lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-bold'><p>Project Manager</p></div>
                    </div>
                  </div>
                </div>
              </div>
            {/* for edit project */}
            <div className="flex-1 ">
                <div className="flex justify-end">
                  {/* <Link to ="/editProjectManager"> */}
                  <div
                    style={{ background: 'radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)' }}
                    className="py-2 lg:w-fit px-2  2xl:px-3 cursor-pointer  flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] ">
                    <div className='text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold'>  <p>Edit Project</p></div>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
          </div>
          <hr
            style={{
              border: "1px solid rgba(205, 205, 205, 1)",
            }}
          />
            {/* maftlal image */}
          <div className="w-full flex flex-row items-center p-6">
            <div className="flex items-center pl-[48px] ">
              <img src={maftlal} alt="maftlal" className="object-cover lg:w-[60px] xl:w-[100px] 2xl:w-[180px]" />
            </div>
            <p className="px-[55px] font-semibold 2xl:text-4xl">Mafatlal App</p>
          </div>
          <hr
            style={{
              border: "1px solid rgba(205, 205, 205, 1)",
            }}
          />
          {/* Development text */}
          <div className="flex justify-center items-center pt-20 text-gray-400 ">
            <div className="text-xl font-semibold cursor-pointer lg:text-xs xl:text-xl 2xl:text-4xl">
              <p>
                Development Related Data Store <br />
                Eg. LINK, FILES, USER LIMIT, KEY
              </p>
            </div>
          </div>
        </div>
        </div>
      </>
    </Sidebar>
  );
}